module.exports = __webpack_public_path__ + "components/media-kit/static/icon-instagram-6f7f616f44e4c4244580338661f876d9.svg";